<template>
    <RouterLink
        ref="itemRef"
        :to="to"
        v-bind="attrs"
        :class="twMerge(
            'flex rounded-1 px-2 paragraph-sm-medium items-center w-full gap-2 cursor-pointer',
            'h-auto py-2',
            selected && 'bg-tertiary',
        )"
    >
        <Tag v-if="type" variant="neutral" size="sm" class="flex-shrink-0">
            {{ type }}
        </Tag>
        <Tag v-if="badge" variant="neutral" size="sm" class="flex-shrink-0">
            {{ badge }}
        </Tag>

        <div class="flex-1 flex flex-col gap-0.5 min-w-0">
            <span class="truncate inline-flex items-center gap-1" :class="inactive && 'text-disabled'" :title="label">
                {{ label }}
                <span v-if="parent" class="paragraph-xs text-secondary">
                    <span>{{ parent }}</span>
                </span>
                <Tag v-if="inactive" variant="neutral" size="sm" class="flex-shrink-0">
                    {{ translate('general.inactive') }}
                </Tag>
            </span>
        </div>

        <Icon v-if="current" name="check" :size="16" />
    </RouterLink>
</template>

<script setup lang="ts">
import { ref, useAttrs, watch } from 'vue'
import { twMerge } from 'tailwind-merge'
import type { RouteLocationRaw } from 'vue-router'
import { RouterLink } from 'vue-router'
import Icon from '@/vue/components/design-system/icon/Icon.vue'
import Tag from '@/vue/components/design-system/tag/Tag.vue'
import { useTranslationsStore } from '@/vue/stores/translationsStore'

const attrs = useAttrs()
const { translate } = useTranslationsStore()

type Props = {
    label: string
    parent?: string
    badge?: string
    current?: boolean
    selected?: boolean
    type?: string
    to: RouteLocationRaw
    inactive?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    parent: undefined,
    badge: undefined,
    current: false,
    selected: false,
    type: undefined,
    inactive: false,
})

const itemRef = ref(null)

// Scroll into view when selected (keyboard navigation)
watch(() => props.selected, (isSelected) => {
    if (isSelected && itemRef.value) {
        const targetEl = (itemRef.value as any).$el as HTMLElement
        targetEl.scrollIntoView({ block: 'nearest' })
    }
})
</script>
